import React from 'react';
import Alert from 'react-s-alert';
import Row from '../../../shared/components/Row';
import Card from '../../../shared/components/Card';
import CardHeader from '../../../shared/components/card-header/CardHeader';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import HeaderSearchRefreshFilterOptions from '../../../shared/components/HeaderSearchRefreshFilterOptions';
import CardBody from '../../../shared/components/CardBody';
import Paginator from '../../../shared/components/Paginator';
import { MachineSearchRequest } from './machine-search/MachineSearchRequest';
import { MachineSearchTask } from './machine-search/MachineSearchTask';
import { MachineStateListTask } from './machine-state-list/MachineStateListTask';
import { PsMachine } from '../PsMachine';
import { MachineListTable } from './MachineListTable';
import PropTypes from 'prop-types';
import MachineState from '../../../shared/model/MachineState';

export class MachineListCard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            data: [],
            error: '',
            search: props.initialCardState.search,
            filter: props.initialCardState.filter,
            loading: false,
            filters: [],
            pagination: {
                current: 0,
                total_pages: 0,
                total_elements: 0,
            },
        };
    }

    componentDidMount() {
        this.listMachineStates();
        this.listMachines();
    }

    componentDidUpdate(_, prevState) {
        const { saveCardState } = this.props;
        const { search, filter } = this.state;

        if ( prevState.filter !== filter ) {
            saveCardState({ filter });
        }

        if ( prevState.search !== search ) {
            saveCardState({ search });
        }
    }

    render() {
        const {
            data,
            error,
            search,
            loading,
            pagination,
        } = this.state;

        return (
            <Row>
                <Card loading={loading}>
                    <CardHeader
                        title={I18nUtils.tr('TR_TODA_LA_MAQUINARIA').toUpperCase()}
                        subtitle={this.subtitle()}
                        rightOptions={(
                            <HeaderSearchRefreshFilterOptions
                                enableFilter={true}
                                filterOptions={this.filterOptions()}
                                searchText={search}
                                onRefresh={this.listMachines}
                                onSearch={this.search}
                            />
                        )}
                    />
                    <CardBody>
                        <MachineListTable
                            data={data}
                            error={error}
                            loading={loading}
                        />
                        <Paginator
                            data={pagination}
                            onPage={this.selectPage}
                        />
                    </CardBody>
                </Card>
            </Row>
        );
    }

    search = (search) => {
        this.setState({ search, page: 1 }, this.listMachines);
    };

    selectPage = (page) => {
        this.setState({ page }, this.listMachines);
    };

    listMachines = () => {
        const { page, search, filter } = this.state;
        const request = new MachineSearchRequest();

        request.setPage(page);
        request.setTerm(search);
        request.setMachineState(filter);

        new MachineSearchTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess((res) => {
                const data = PsMachine.fromAPIMachines(res.data);
                this.setState({ data, pagination: res.pagination });
            })
            .onFail(error => this.setState({ error }))
            .onPostExecution(() => this.setState({ loading: false }))
            .execute();
    };

    listMachineStates = () => {
        new MachineStateListTask()
            .onSuccess((res) => {
                const filters = this.parseToFilterOptions(res.data);
                this.setState({ filters });
            })
            .onFail((error) => Alert.error(error))
            .execute();
    };

    parseToFilterOptions = (states) => {
        const options = [{
            id: -1,
            title: I18nUtils.tr('TR_TODOS'),
            onClick: () => this.setState({ filter: -1, page: 1 }, this.listMachines),
        }];

        states.forEach((state) => {
            options.push({
                id: state.id,
                title: state.name,
                onClick: () => this.setState({ filter: state.id, page: 1 }, this.listMachines),
            });
        });

        return options;
    };

    filterOptions = () => {
        return this.state.filters.map((filter) => ( {
            ...filter,
            active: filter.id === this.state.filter,
        } ));
    };

    subtitle = () => {
        const currentFilter = this.state.filters.find((f) => f.id === this.state.filter);
        return currentFilter ? currentFilter.title : '';
    };
}

MachineListCard.propTypes = {
    saveCardState: PropTypes.func,
    initialCardState: PropTypes.object.isRequired,
};

MachineListCard.defaultProps = {
    saveCardState: () => null,
    initialCardState: {
        search: '',
        filter: MachineState.ALL,
    },
};



// WEBPACK FOOTER //
// ./src/app/my-contractors/machine/list/MachineListCard.jsx